import { render, staticRenderFns } from "./SellersHome.vue?vue&type=template&id=64bf4546&scoped=true&"
import script from "./SellersHome.vue?vue&type=script&lang=js&"
export * from "./SellersHome.vue?vue&type=script&lang=js&"
import style0 from "./SellersHome.vue?vue&type=style&index=0&id=64bf4546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf4546",
  null
  
)

export default component.exports